export class ResourceSubCategory {
    id?: number;
    name?: any;
    created_at?: any;
    data?: any;
    product_resource_category_id?: number
}